(() => {
  if (customElements.get('yuumae-community')) return;
  customElements.define('yuumae-community', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.rail = this.querySelector('[data-rail]');
      this.cards = [...this.rail.children];
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.pausedByUser = this.motion.matches || navigator.connection?.saveData;
      this.visible = false;
      this.cards.forEach(card => {
        const video = card.querySelector('video');
        if (!video) return;
        video.controls = false;
        video.muted = true;
        card.querySelector('.yuumae-community-video-controls').hidden = false;
        const update = () => {
          card.classList.toggle('is-playing', !video.paused);
          card.querySelector('[data-community-play]').setAttribute('aria-label', video.paused ? this.dataset.play : this.dataset.pause);
          const sound = card.querySelector('[data-community-sound]');
          sound.setAttribute('aria-label', video.muted ? this.dataset.unmute : this.dataset.mute);
          sound.setAttribute('aria-pressed', String(!video.muted));
        };
        ['play', 'pause', 'volumechange'].forEach(name => video.addEventListener(name, update, options));
        video.addEventListener('error', () => {
          card.classList.remove('is-playing');
          card.querySelector('.yuumae-community-video-controls').hidden = true;
          video.controls = true;
        }, options);
      });
      this.addEventListener('click', event => {
        const play = event.target.closest('[data-community-play]');
        const sound = event.target.closest('[data-community-sound]');
        if (!play && !sound) return;
        const card = (play || sound).closest('.yuumae-community-card');
        const video = card.querySelector('video');
        const pause = play && this.current === card && !video.paused;
        this.select(card);
        this.pausedByUser = !!pause;
        this.playBlocked = false;
        if (sound) video.muted = !video.muted;
        this.update();
      }, options);
      this.rail.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.selectNearest());
      }, { ...options, passive: true });
      this.resize = new ResizeObserver(() => this.selectNearest());
      this.resize.observe(this.rail);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if (this.visible) this.selectNearest();
        this.update();
      }, { threshold: .15 });
      this.observer.observe(this.rail);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) { this.pausedByUser = true; this.update(); }
      }, options);
      document.addEventListener('visibilitychange', () => this.update(), options);
      document.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.yuumae-community-card');
        if (card && this.contains(card)) card.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'center' });
      }, options);
    }
    selectNearest() {
      const rect = this.rail.getBoundingClientRect();
      const center = rect.left + rect.width / 2;
      const nearest = this.cards.reduce((best, card) => {
        const bounds = card.getBoundingClientRect();
        const distance = Math.abs(bounds.left + bounds.width / 2 - center);
        return !best || distance < best.distance ? { card, distance } : best;
      }, null);
      if (nearest) this.select(nearest.card);
    }
    select(card) {
      if (card === this.current) return;
      const previous = this.current?.querySelector('video');
      if (previous) { previous.pause(); previous.muted = true; }
      this.current?.classList.remove('is-current');
      this.current = card;
      card.classList.add('is-current');
      this.playBlocked = false;
      this.update();
    }
    update() {
      const video = this.current?.querySelector('video');
      if (!video) return;
      if (!this.visible || document.hidden || this.pausedByUser) video.pause();
      else if (video.paused && !this.playBlocked) video.play().catch(() => {
        if (this.current?.querySelector('video') === video) this.playBlocked = true;
      });
    }
    disconnectedCallback() {
      this.abort?.abort(); this.resize?.disconnect(); this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.cards?.forEach(card => card.querySelector('video')?.pause());
    }
  });
})();
